import React from 'react';
import { useTranslation } from 'react-i18next';
import { NewsArticle } from '../types';
import './Article.css';

interface ArticleProps {
  article: NewsArticle;
}

const Article: React.FC<ArticleProps> = ({ article }) => {
  const { t } = useTranslation();
  return (
    <article className="article">
      <div className="article-header">
        <h1 className="article-title">{article.title}</h1>
        <div className="article-meta">
          <span className="article-date">
            {new Date(article.publishDate).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </span>
          <span className="article-author">By {article.author}</span>
        </div>
        {article.tags && article.tags.length > 0 && (
          <div className="article-tags">
            {article.tags.map((tag, index) => (
              <span key={index} className="article-tag">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
      
      <div className="article-content">
        <p className="article-excerpt">{article.excerpt}</p>
        {article.image && (
          <div className="article-image">
            <img 
              src={article.image} 
              alt={article.title}
              className="article-main-image"
            />
          </div>
        )}
        <div className="article-body">
          {article.content.split('\n').map((line, index) => {
            // Check if line is an image markdown syntax
            const imageMatch = line.match(/^!\[([^\]]*)\]\(([^)]+)\)$/);
            if (imageMatch) {
              const [, altText, imageSrc] = imageMatch;
              return (
                <div key={index} className="article-image">
                  <img 
                    src={imageSrc} 
                    alt={altText}
                    className="article-content-image"
                  />
                </div>
              );
            }
            // Regular paragraph
            return (
              <p key={index} className="article-paragraph">
                {line}
              </p>
            );
          })}
        </div>
      </div>

      {article.source && (
        <div className="article-source">
          <h3>{t('common.source')}</h3>
          <p>
            {t('common.originallyPublishedOn')}{' '}
            <a 
              href={article.source} 
              target="_blank" 
              rel="noopener noreferrer"
              className="source-link"
            >
              Telegrafi.com
            </a>
          </p>
        </div>
      )}

      <div className="article-actions">
        <a href="/media/news" className="btn btn-secondary">
          {t('common.backToNews')}
        </a>
        <a href="/" className="btn btn-primary">
          {t('common.home')}
        </a>
      </div>
    </article>
  );
};

export default Article;
